<script lang="ts">
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import type { LocationOptionsResponse } from "../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import type { ParsedLocationResponse } from "../../../../GlobalHelper/GoogleMapsHelper";
    import { user } from "../../../../store/stores";
    import Tags from "../../Components/Tags/Tags.svelte";
    import NewLocationMap from "./Components/NewLocationMap.svelte";

    export let networkId: string;

    const navigate = useNavigate();

    let addressObject = {
        city: null,
        addressLine1: null,
        addressLine2: null,
        postalCode: null,
    };
    let geoLocation = {
        latitude: null,
        longitude: null,
    };
    let locationId = "";
    let activeState = false;
    let openSMAddress = "";
    let addressResponse: ParsedLocationResponse = null;
    let fetching: boolean = false;
    let status: boolean | null = null;
    let errorMessage: string = "Die Erstellung ist fehlgeschlagen.";

    let options: LocationOptionsResponse = null;
    const handleOSMLocationResponse = (res: ParsedLocationResponse) => {
        addressResponse = res;
    };

    const createNewLocation = async () => {
        if (
            locationId &&
            locationId !== "" &&
            geoLocation.latitude &&
            geoLocation.longitude
        ) {
            await $user.updateToken().then(async () => {
                ApiClient.getInstance()
                    .locationClient.createLocation({
                        locationRequest: {
                            active: true,
                            name: locationId,
                            address: {
                                ...addressObject,
                            },
                            geoLocation: {
                                ...geoLocation,
                            },
                            networkId: networkId,
                            tags: [],
                        },
                    })
                    .then((result) => {
                        fetching = false;
                        status = true;
                    })
                    .catch((error) => {
                        fetching = false;
                        status = false;
                        errorMessage = error;
                    });
            });
        }
    };

    const getOptions = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .locationClient.getLocationOptions({})
                .then((resp) => (options = resp));
        });
    };

    onMount(() => {
        getOptions();
    });
</script>

<div class="container">
    <section class="section">
        <div class="columns">
            <div class="column is-half">
                {#if status}
                    <div class="notification is-success">
                        <button
                            class="delete"
                            on:click={() => (status = null)}
                        />
                        <p>
                            Die Location mit der ID <b>{locationId}</b> wurde angelegt.
                        </p>
                    </div>
                {:else if status === false}
                    <div
                        class="notification is-danger"
                        on:click={() => (status = null)}
                    >
                        <button class="delete" />
                        <p>{errorMessage}</p>
                    </div>
                {/if}
                <div class="box">
                    <div class="field">
                        <label for="locationId" class="label field-name"
                            >Location ID</label
                        >
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Location ID"
                                name="locationId"
                                bind:value={locationId}
                            />
                        </div>
                    </div>
                    <div class="field">
                        <label for="addressLine1" class="label field-name"
                            >Adresse</label
                        >
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Adresse"
                                name="addressLine1"
                                bind:value={addressObject.addressLine1}
                            />
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Adresse - 2. Zeile"
                                name="addressLine2"
                                bind:value={addressObject.addressLine2}
                            />
                        </div>
                    </div>
                    <div class="field-body field-margin">
                        <div class="field">
                            <div class="control">
                                <input
                                    class="input"
                                    type="text"
                                    placeholder="Postleitzahl"
                                    name="postalCode"
                                    bind:value={addressObject.postalCode}
                                />
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input
                                    class="input"
                                    type="text"
                                    placeholder="Stadt"
                                    name="city"
                                    bind:value={addressObject.city}
                                />
                            </div>
                        </div>
                    </div>
                    <button
                        class="button"
                        on:click={() => {
                            openSMAddress = [
                                addressObject.addressLine1,
                                addressObject.postalCode,
                                addressObject.city,
                            ]
                                .filter((part) => part && part !== "")
                                .join(" ");
                        }}
                    >
                        Suchen
                    </button>
                    {#if addressResponse && addressResponse.display_name}
                        <div class="notification is-primary">
                            <button class="delete" />
                            Wir haben folgende Adresse gefunden:
                            <br />
                            {addressResponse.display_name}
                            <br />
                            <button
                                class="button"
                                on:click={() => {
                                    addressObject = {
                                        addressLine1:
                                            addressResponse.addressLine1,
                                        addressLine2:
                                            addressObject.addressLine2,
                                        postalCode: addressResponse.postcode,
                                        city: addressResponse.locality,
                                    };
                                    geoLocation = {
                                        latitude: addressResponse.lat,
                                        longitude: addressResponse.lng,
                                    };
                                }}>Übernehmen</button
                            >
                        </div>
                    {/if}
                    <div class="field ">
                        <!-- svelte-ignore a11y-label-has-associated-control -->
                        <label class="label">Status</label>
                        <div class="control">
                            <div class="select">
                                <select bind:value={activeState}>
                                    <option value={true}>aktiv</option>
                                    <option value={false}>deaktiviert</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label for="" class="label">Tags</label>
                        <Tags />
                    </div>
                    <div
                        class="field is-grouped is-flex is-justify-content-space-between"
                    >
                        <div class="control">
                            <button
                                class="button is-link {fetching
                                    ? 'is-loading'
                                    : ''}"
                                on:click={() => createNewLocation()}
                                disabled={!locationId ||
                                    locationId === "" ||
                                    !geoLocation.latitude ||
                                    !geoLocation.longitude}
                            >
                                Erstellen
                            </button>
                        </div>
                        <div class="control">
                            <button
                                class="button is-link is-light"
                                on:click={() => navigate(-1)}>Abbrechen</button
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-half">
                <NewLocationMap
                    address={openSMAddress}
                    handleLocationResponse={handleOSMLocationResponse}
                />
            </div>
        </div>
    </section>
</div>

<style>
    .field-margin {
        margin-bottom: 0.75rem;
    }
    .field-name {
        text-align: left;
    }
</style>
